import { usePathname } from "expo-router";
import React from "react";
import { TextInputProps } from "react-native";

import HeaderView from "./HeaderView";

import { useTheme } from "@/providers/ThemeProvider";

/**
 * Container for the roster management header with search functionality.
 * @param props - Text input props for configuring the search field behavior and styling
 */
const HeaderContainer = (props: TextInputProps) => {
  const pathname = usePathname();
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";

  return <HeaderView pathname={pathname} isDark={isDark} {...props} />;
};

export default HeaderContainer;
